import { enumObject, EnumValue } from '@/utils';

const ARTICLE_STATUS_VALUES = ['Draft', 'Published', 'Hidden'] as const;

export type ArticleStatus = EnumValue<typeof ARTICLE_STATUS_VALUES>;

// eslint-disable-next-line
export const ArticleStatus = enumObject('ArticleStatus', ARTICLE_STATUS_VALUES);

export type AddArticleDto = {
  title: string;
  shortDescription: string | null;
  description: string;
  attachmentIds?: string[] | null;
};

export interface ArticleDto {
  id: string;
  number: string;
  title: string;
  description: string;
  status: ArticleStatus;
  updatedAt: string;
  shortDescription: string | null;
}

export interface ArticleLookupDto {
  id: string;
  number: string;
  title: string;
  status: ArticleStatus;
  updatedAt: string;
  shortDescription: string | null;
}

export interface UpdateArticleDto {
  id: string;
  title: string;
  description: string;
  shortDescription: string | null;
  attachmentIds?: string[] | null;
}
